var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FormInput", {
    attrs: {
      value: _vm.value,
      placeholder: _vm.placeholder,
      name: "input_filter",
      height: "lg",
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }